var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",staticStyle:{"height":"100%"}},[_c('keep-alive',[(_vm.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.keepAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }